import _extends from "@babel/runtime/helpers/extends";
// This file is copied to `packages/editor/editor-plugin-ai/src/ui/components/AtlassianIntelligenceToolbarButton/ToolbarButton/styles.tsx`
// If you make any change here, copy it to above file as well
//  and notify about the change in #team-fc-editor-ai-dev channel.
import React from 'react';
import Button from '@atlaskit/button/standard-button';
export default /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Button, _extends({
    ref: ref
  }, props, {
    style: {
      alignItems: 'center'
    }
  }));
});